import { RISING } from '@/mocks/trending';

export default function Rising() {
  const maxRise = 312;
  return (
    <section id="rising" className="scroll-mt-24 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800 border border-accent-200">
              <i className="ri-rocket-2-line" aria-hidden="true"></i>上升最快
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              正在<span className="text-accent-600">起飞</span>的话题
            </h2>
            <p className="mt-2 max-w-xl text-sm md:text-base text-foreground-600">
              按单位时间热度增量排序，越靠前说明冲得越猛，是捕捉"下一秒爆瓜"的优先观察对象。
            </p>
          </div>
          <a
            href="#hot"
            className="inline-flex items-center gap-1.5 self-start rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition hover:border-accent-300 hover:text-accent-700 md:self-auto"
          >
            返回完整热榜
            <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
          </a>
        </div>

        <ol className="mt-7 grid gap-3 md:mt-8 md:grid-cols-2">
          {RISING.map((r, i) => {
            const first = i === 0;
            const fill = Math.max(24, Math.round((Number(r.rise.replace('%', '').replace('+', '')) / maxRise) * 100));
            return (
              <li
                key={r.id}
                className={`relative flex flex-col gap-3 overflow-hidden rounded-xl border p-4 md:p-5 transition ${
                  first
                    ? 'border-accent-300 bg-accent-50'
                    : 'border-background-200 bg-background-100 hover:border-accent-200'
                }`}
              >
                <div className="flex items-center gap-3">
                  <span
                    className={`flex h-8 w-8 items-center justify-center rounded-lg font-heading text-base font-black ${
                      first ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {i + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center justify-between gap-2">
                      <span className="whitespace-nowrap rounded-full bg-accent-500/90 px-2 py-0.5 text-[11px] font-bold text-background-50">
                        {r.rise}
                      </span>
                      {first && (
                        <span className="whitespace-nowrap rounded-full bg-background-50 px-2 py-0.5 text-[11px] font-semibold text-accent-700 border border-accent-200">
                          今日最快
                        </span>
                      )}
                    </div>
                    <h3 className="mt-2 font-medium text-foreground-950">{r.title}</h3>
                    <p className="mt-0.5 text-xs text-foreground-500">实时热度 {r.heat}</p>
                  </div>
                </div>
                <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className={`h-full rounded-full ${first ? 'bg-accent-500' : 'bg-accent-300'}`}
                    style={{ width: `${fill}%` }}
                  ></div>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}